
// TODO swap fetch for axios when npm setup
export class ProhibitedListClientManager {
  // static basePath = "/list/prohibited-list";
  //
  // TODO enum when ts setup
  // static SearchSortType = {
  //   Relevancy: "Relevancy",
  //   Title: "Title",
  //   Author: "Author",
  //   PubDate: "PubDate",
  //   Rating: "Rating",
  //   NewlyAdded: "NewlyAdded",
  //   CallNumber: "CallNumber",
  // };

  static async getList(
    listId,
    firstResult = 0,
    maxResults = 20,
    sortType = ProhibitedListClientManager.SearchSortType.Relevancy
  ) {
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}/${firstResult}/${maxResults}/${sortType}`
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async createList(listName, childIds = []) {
    const payload = JSON.stringify({
      listName,
      childIds,
    });

    return fetch(`${ProhibitedListClientManager.basePath}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: payload,
    })
      .then((response) => {
        if (response.ok) {
            // TODO chain then that checks success flag and throws if false
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async renameList(listId, listName) {
    const payload = listName;
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async deleteList(listId) {
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async getListSummaries() {
    return fetch(`${ProhibitedListClientManager.basePath}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async setListChildren(listId, childIds) {

    const payload = JSON.stringify(childIds);
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}/children`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));

  }

  static async addRecords(listId, resourceIds = []) {
    const payload = JSON.stringify(resourceIds);
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}/records/add`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }

  static async deleteRecords(listId, resourceIds = []) {
    const payload = JSON.stringify(resourceIds);
    return fetch(
      `${ProhibitedListClientManager.basePath}/${listId}/records/delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status);
        }
      })
      .catch((error) => console.error(error));
  }
}

ProhibitedListClientManager.basePath = "/list/prohibited-list";

ProhibitedListClientManager.SearchSortType = {
    Relevancy: "Relevancy",
    Title: "Title",
    Author: "Author",
    PubDate: "PubDate",
    Rating: "Rating",
    NewlyAdded: "NewlyAdded",
    CallNumber: "CallNumber",
};